// Public-page wrapper that fetches a page's blocks by slug and renders them.
// Renders nothing if no blocks exist (so existing designed heroes remain unchanged).
import { useEffect, useState } from "react";
import api from "@/lib/api";
import BlockRenderer from "./BlockRenderer";

export default function EditableSection({ slug }) {
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    let cancel = false;
    api.get(`/pages/${slug}`).then((r) => {
      if (cancel) return;
      setBlocks(r.data?.blocks || []);
    }).catch(() => setBlocks([]));
    return () => { cancel = true; };
  }, [slug]);

  if (!blocks || blocks.length === 0) return null;
  return (
    <div data-testid={`editable-section-${slug}`}>
      {blocks.map((b) => <BlockRenderer key={b.id} block={b} />)}
    </div>
  );
}
